import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import cn from "classnames";

import styles from '../../lib/global.css';
import Page from '../../components/page/page';
import Footer from '../../components/footer/footer.jsx';

import {getCourses} from '../../api/course';

import CourseList from "../../components/course-list/course-list";
import {setCourseRecords, setCourses} from "../../reducers/teach";
import {getCourseRecords} from "../../api/course-record";
import CourseRecordList from "../../components/course-record-list/course-record-list";
import Card from "../../components/card/card";
import PageContentMargin from "../../components/page-content-margin/page-content-margin";

/**
 * 课程列表页
 */
class  CoursesPage extends React.PureComponent{
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        if (this.props.match.params.filter == 'studying') {
            getCourseRecords({studying:1, page_size: 100}).then(res => this.props.setCourseRecords(res));
        }
        getCourses({page_size:100}, {quiet: this.props.courses.data.length > 0}).then(res => this.props.setCourses(res));
    }

    render() {
        const title = this.props.match.params.filter == 'studying' ? window.L('teach.course.studyingCourses'): window.L('teach.course.recommendedCourses');
        return (
            <Page isModal={true} title={title}>
                <PageContentMargin>
                    {(this.props.match.params.filter == 'studying') ? (
                        <CourseRecordList
                            items={this.props.courseRecords.data}
                        />
                    ) : null}
                    {(this.props.courses && this.props.courses.data.length > 0) ? (
                        <Card title={window.L('teach.course.recommendedCourses')} subTitle={window.L('teach.course.recommendedCoursesSubtitle')}>
                            <CourseList
                                items={this.props.courses.data}
                            />
                        </Card>
                    ) : null}
                </PageContentMargin>
                <Footer/>
            </Page>
        );
    }
}

CoursesPage.propTypes = {
    courses: PropTypes.object,
    courseRecords: PropTypes.object,
    setCourses: PropTypes.func,
    setCourseRecords: PropTypes.func
};

const mapStateToProps = state => ({
    courses: state.teach.courses,
    courseRecords: state.teach.courseRecords,
});


const mapDispatchToProps = dispatch => ({
    setCourses: courses => dispatch(setCourses(courses)),
    setCourseRecords: courseRecords => dispatch(setCourseRecords(courseRecords)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CoursesPage);
